import apiClient from './apiClient';

/**
 * Newsletter campaigns + guest audience targeting.
 *
 * Backed by the adapter API at /api/v1/marketing/* (camelCase payloads, no
 * trailing slashes) — not the DRF router, so these paths deliberately differ
 * from guestService's.
 */
const newsletterService = {
  // Campaigns
  list: (params) => apiClient.get('/v1/marketing/campaigns', params),
  get: (id) => apiClient.get(`/v1/marketing/campaigns/${id}`),
  create: (data) => apiClient.post('/v1/marketing/campaigns', data),
  update: (id, data) => apiClient.patch(`/v1/marketing/campaigns/${id}`, data),
  remove: (id) => apiClient.del(`/v1/marketing/campaigns/${id}`),

  // Campaign actions
  send: (id) => apiClient.post(`/v1/marketing/campaigns/${id}/send`, {}),
  cancel: (id) => apiClient.post(`/v1/marketing/campaigns/${id}/cancel`, {}),
  duplicate: (id) => apiClient.post(`/v1/marketing/campaigns/${id}/duplicate`, {}),
  testSend: (id, data) => apiClient.post(`/v1/marketing/campaigns/${id}/test-send`, data),
  preview: (id, data) => apiClient.post(`/v1/marketing/campaigns/${id}/preview`, data || {}),
  recipients: (id, params) => apiClient.get(`/v1/marketing/campaigns/${id}/recipients`, params),

  // Visual block editor
  templates: () => apiClient.get('/v1/marketing/templates'),
  // Renders an unsaved design — no campaign row needed just to look at it.
  draftPreview: (data) => apiClient.post('/v1/marketing/preview', data),
  listImages: () => apiClient.get('/v1/marketing/images'),
  uploadImage: (file) => {
    const form = new FormData();
    form.append('image', file);
    return apiClient.postForm('/v1/marketing/images', form);
  },

  // Audience
  previewAudience: (filters) =>
    apiClient.post('/v1/marketing/audience/preview', { filters }),
  audienceOptions: () => apiClient.get('/v1/marketing/audience/options'),
  placeholders: () => apiClient.get('/v1/marketing/placeholders'),

  // Suppression list
  optOuts: (params) => apiClient.get('/v1/marketing/opt-outs', params),
  addOptOut: (data) => apiClient.post('/v1/marketing/opt-outs', data),
  removeOptOut: (id) => apiClient.del(`/v1/marketing/opt-outs/${id}`),
};

export default newsletterService;
